import { useMemo } from 'react';
import { OrganizationWrapper } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Organization';
import { useOrganizations } from 'src/careflow/ph-core/fhir-client/fhir-react';
import useAuth from 'src/careflow/ph-core/authentication/hook/useAuth';
import { Reference } from 'src/careflow/ph-core/fhir-client/resources';
import OrganizationSelect from 'src/careflow/common/OrganizationSelect';

interface Props {
  value: Reference | null;
  onChange: (ref: Reference | null) => void;
}

const SchoolEnrolledSelect = ({ value, onChange }: Props) => {
  const auth = useAuth();

  const userOrgId = useMemo(() => {
    const org = auth.getSelectedOrg();
    const splitArry = org.fhir_uri.split('/');
    return splitArry[splitArry.length - 1];
  }, [auth]);

  const [organizations, { isLoading }] = useOrganizations({
    filter: { _id: userOrgId, '_revinclude:iterate': 'Organization:partof' },
    map: OrganizationWrapper,
  });

  return (
    <OrganizationSelect
      organizations={organizations as any}
      selectedOrganizationRef={value}
      onValueChange={onChange}
      isLoading={isLoading}
    />
  );
};

export default SchoolEnrolledSelect;
